// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/style/style.scss'
import Icon from '@/elements/Icon'
import { sync } from 'vuex-router-sync'
// import VueGtm from 'vue-gtm'

require('es6-shim')
require('custom-event-polyfill')
require('@/config/axios')
sync(store, router)

// Moment
const moment = require('moment')
require('moment/locale/nb')
Vue.use(require('vue-moment'), { moment })

// GoogleTagManager
// Vue.use(VueGtm, {
//   vueRouter: router
// })

// Google analytics
// Vue.use(VueAnalytics, {
//   id: 'UA-8787381-70',
//   router
// })

Vue.config.productionTip = false

Vue.component('t-icon', Icon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js